import { Injectable } from '@angular/core';
import { ManagementStoreService } from './management-store.service';
import { ManagementApiService } from '@emm/management/services/management-api.service';
import {SearchFilter} from '@emm/core/models/search-filter';

@Injectable({
  providedIn: 'root'
})
export class LanguageAssignmentsFacadeService {

  filteredOptions$ = this.managementStore.queryLanguageAssignments.all$;
  centerLoading$ = this.managementStore.isLoading$.languageAssignments;

  constructor(private managementStore: ManagementStoreService,
              private api: ManagementApiService) { }

  init(): void {
    this.managementStore.dispatch.initLanguageAssignments();
  }

  searchLocation(searchFilter: SearchFilter): void {
    this.managementStore.dispatch.searchLocation(searchFilter);
  }
}
